import { createAction } from 'redux-actions';

export const selectOwner = createAction('PRODUCTION_UNIT_ADD_SELECT_OWNER');
